var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div", attrs: { id: "ms_header_downside" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("section", [
                  _vm._m(1),
                  _vm._v(" "),
                  !_vm.isHaseko
                    ? _c("div", [
                        _c("a", { attrs: { href: "tel:0362761123" } }, [
                          _c("img", {
                            attrs: { src: _vm.getImage("bunner/TEL.webp") }
                          })
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("section", { attrs: { id: "what_mmstyle" } }, [
                  _c("h2", [
                    _vm._v(
                      "1ミリ単位のサイズオーダー × お部屋のスタイルに合わせたデザイン"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "procedure_with_img" }, [
                    _c("div", [
                      _c("img", {
                        attrs: { src: _vm.getImage("about/01_design.webp") }
                      })
                    ]),
                    _vm._v(" "),
                    _vm._m(2)
                  ])
                ]),
                _vm._v(" "),
                _c("section", { attrs: { id: "low_price" } }, [
                  _c("h2", [_vm._v("高品質なのに、低価格な理由")]),
                  _vm._v(" "),
                  _vm._m(3),
                  _vm._v(" "),
                  _c("section", [
                    _vm._m(4),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    _c("img", {
                      attrs: { src: _vm.getImage("about/02-01_ftoc.webp") }
                    })
                  ]),
                  _vm._v(" "),
                  _c("section", [
                    _vm._m(6),
                    _vm._v(" "),
                    _vm._m(7),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: _vm.getImage("about/02-02_automation.webp")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("section", { attrs: { id: "cost_cut" } }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _vm._m(9),
                    _vm._v(" "),
                    _c("div", { staticClass: "center_img" }, [
                      _c("img", {
                        attrs: { src: _vm.getImage("about/02-03_cost.webp") }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "detail_btn btn_pos_center",
                        on: {
                          click: function($event) {
                            _vm.routeCategory()
                          }
                        }
                      },
                      [_vm._v("商品を選ぶ 〉〉")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [_vm._v("従来の収納家具・オーダー家具との比較")]),
                  _vm._v(" "),
                  _vm._m(10),
                  _vm._v(" "),
                  _c("img", {
                    attrs: { src: _vm.getImage("about/03_table.webp") }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "detail_btn btn_pos_center",
                      on: {
                        click: function($event) {
                          _vm.routeCategory()
                        }
                      }
                    },
                    [_vm._v("商品を選ぶ 〉〉")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "section",
                  [
                    _c("h2", [_vm._v("お客様に選ばれる3つの理由")]),
                    _vm._v(" "),
                    _c("dd-reason")
                  ],
                  1
                ),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [_vm._v("会員登録するとこんなに便利！")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "ul_user_register" }, [
                    _c("li", [
                      _c("h3", [_vm._v("①会員限定価格での商品購入")]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: { src: _vm.getImage("about/04-01_special.webp") }
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "会員様限定の割引価格にて商品をご購入いただけるようになります。"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("h3", [_vm._v("②メールマガジンでお得な情報をお届け")]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: { src: _vm.getImage("about/04-02_mail.webp") }
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "クーポンや新商品、キャンペーンの情報などをいち早くお届けいたします。"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("h3", [_vm._v("③カスタマイズ情報の保存")]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: { src: _vm.getImage("about/04-03_save.webp") }
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "カスタマイズ中の商品情報を保存しておくことができます。"
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "detail_btn btn_pos_center",
                      on: {
                        click: function($event) {
                          _vm.route("DcSignUp")
                        }
                      }
                    },
                    [_vm._v("会員登録はこちら 〉〉")]
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "meinmenu_title" }, [
      _c("div", [_vm._v("RASHIKUのご紹介")]),
      _vm._v(" "),
      _c("div", [_vm._v("はじめてのお客様へ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "start_ms" } }, [
      _c("p", [
        _vm._v(
          "\n              規格サイズの収納家具を検討されてる皆様！一度お待ちください！"
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "\n              私たちRASHIKUは、従来の規格サイズの収納家具では解決できない、"
        ),
        _c("span", { staticClass: "pickup" }, [
          _vm._v(
            "お部屋の間取りやスタイルに合わせた収納家具を全国配送にて販売する専門サイトです。"
          )
        ]),
        _vm._v(
          "\n              収納でお困りのお客様にご満足いただけるよう、豊富なデザインから選択いただいた家具を、"
        ),
        _c("span", { staticClass: "pickup" }, [_vm._v("1mm単位でサイズ調整")]),
        _vm._v("でき、"),
        _c("span", { staticClass: "pickup" }, [_vm._v("カラーも自由")]),
        _vm._v("にお選びいただけます。"),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "\n              吊戸棚（フロート収納）からテレビボード、食器棚（カップボード）など、お部屋のあらゆる収納をとり揃えており、"
        ),
        _c("br"),
        _vm._v(
          "\n              『既製品では不満だけど、フルオーダーは高くて ・・・ 』"
        ),
        _c("br"),
        _vm._v("\n              『内装・建具の色柄と合う収納が欲しい』"),
        _c("br"),
        _vm._v(
          "\n              『壁から壁までのジャストフィットの収納が欲しい』"
        ),
        _c("br"),
        _vm._v(
          "\n              という皆様のお困りごとを、RASHIKUが全て解決したします！"
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "\n              収納家具選びで迷われている皆様、まずはご相談ください。\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n                RASHIKUでは、収納家具を1mm単位でサイズ オーダーが可能、お部屋に合わせた無駄のない収納家具をご購入いただけます。"
        ),
        _c("br"),
        _vm._v(
          "\n                規格サイズの家具と異なり、お部屋に収納家具がジャストフィットし、すっきりと納まった見た目になります。"
        ),
        _c("br"),
        _vm._v(
          "\n                また、お部屋のスタイルに合わせて、さまざまなデザインの収納家具からお選びいたただくことができます。\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n            ドゥーマンズは、お客様が本当の意味で住心地を改善いただけるよう、RASHIKUをご活用いただければ、と考えております。"
      ),
      _c("br"),
      _vm._v(
        "\n            高品質なオーダー家具を低価格でお客様にご提供させていただく仕組みをご案内させてください。"
      ),
      _c("br"),
      _vm._v(
        "\n            ・商品を製造工場からお客様の元へ直送させていただくことで、低価格を実現しております。"
      ),
      _c("br"),
      _vm._v(
        "\n            ・従来のオーダー家具は、設計や製造に非常に手間と時間がかかります。"
      ),
      _c("br"),
      _vm._v(
        "\n              RASHIKUは独自の特許取得済みのシステムにより、この手間と時間をなくすことで、低価格を実現しております。\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", [_vm._v("1.")]),
      _vm._v("国内工場からお客様の元まで直送")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n              通常、お客様の元に家具が届くまでには、たくさんの会社が関わっています。商品を企画するメーカー、製造する工場、製造品を流通させる商社、\n              お客様に販売する小売店。お客様が購入する商品の価格は、それぞれの会社の利益が上乗せされた価格です。"
      ),
      _c("br"),
      _vm._v(
        "\n              RASHIKUでは、工場が商品を企画・製造し、お客様の元へ直接お届けします。関係する会社が少ない分、価格が安くなるという仕組みです。"
      ),
      _c("br"),
      _vm._v(
        "\n              また、長く日本国内の最高品質基準を達成してきた工場のみが、RASHIKUに商品を掲載しています。自信を持って良い商品をお届けいたしますので、ご安心ください。\n            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", [_vm._v("2.")]),
      _vm._v("製造指示等の作業を独自システムにより自動化")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n              従来のオーダー家具の製造・販売には、膨大な時間と手間がかかります。  お客様のご要望を聞き、設計図を描き、必要な資材を考え、販売金額を計算し、\n              ご要望が叶えられる内容になるまでこのプロセスを繰り返します。 全て一品ものとして設計されるため、製造においても職人がそれぞれの工程を細かく指示しなければなりません。"
      ),
      _c("br"),
      _vm._v(
        "\n              RASHIKUに掲載されている商品は、特許取得済みの独自技術により上記のプロセスが全て自動化されています。  その結果、人件費が大幅に削減され、\n              低価格のオーダー家具となっており、自動化されているためさまざななミスも発生せず、高品質の商品となっております。\n            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", [_vm._v("3.")]),
      _vm._v("徹底的なコストカット")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n              RASHIKU は、テレビCM等の広告を行っておりません。商品を梱包するダンボールにブランド名を印刷しないなど、可能な限り不要なコストを削減しています。"
      ),
      _c("br"),
      _vm._v(
        "\n              お客様に満足いただける商品を、満足いただける価格で提供させていただきます。\n            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n            既製品やオーダー家具、それぞれにメリットとデメリットがあります。"
      ),
      _c("br"),
      _vm._v(
        "\n            それらと比べて、RASHIKUの商品はバランスが良いオーダー家具となっております。"
      ),
      _c("br"),
      _vm._v(
        "\n            その理由は、RASHIKUが、サイズ・色柄種類のオーダー性を持ちながらも、さまざまな価格バリエーションの家具を購入できるサイトとして、運営されているからです。\n          "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f8b694be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8b694be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcAbout2.vue
// module id = null
// module chunks = 